import React from 'react';
import {inject, observer} from "mobx-react";
import { AxlModal, AxlPanel, AxlButton, AxlUploadCropImage } from 'axl-reactjs-ui';

import styles, * as E from './styles';

@inject('clientStore')
@inject('userStore')
@observer
class AccountLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenCropper: false,
      tempImg: null,
    }
  }

  openCropperImage = () => {
    this.setState({isOpenCropper: true})
  }

  closeCropperImage = () => {
    this.setState({isOpenCropper: false})
  };

  uploadImage = (files) => {
    const { clientStore, userStore } = this.props;
    if (files && files.length > 0) {
      const blob = new Blob(files, {"type": "image"});
      const tempBlob = URL.createObjectURL(blob);

      clientStore.uploadPhoto(files[0], () => {
        userStore.setLogo(tempBlob);
        this.setState({
          isOpenCropper: false,
          tempImg: tempBlob,
        });
      });
    }
  };

  render() {
    const { clientStore } = this.props;
    const { settingsForm, uploadingLogo } = clientStore;
    let fileName = settingsForm.data.logo_url ? settingsForm.data.logo_url.split('/').pop() : null;
    fileName = fileName ? fileName.split('?').shift() : null;

    // valid image file name
    if( fileName && !(/\.(jpe?g|png|gif|bmp)$/i.test(fileName)) ) {
      fileName = null;
    }

    return <E.Container>
      <AxlPanel>
        <E.Label>{`Upload your logo to customize the label template`}</E.Label>
        <AxlPanel.Row style={styles.Row}>
          <div style={{marginRight: 10, minWidth: 185}}>
            {settingsForm.data.logo_url && <E.ImageReview><E.Image src={this.state.tempImg || settingsForm.data.logo_url} /></E.ImageReview>}
            {fileName && <E.FileName>{fileName}</E.FileName>}
          </div>
          <E.Row_1>
            <AxlButton compact bg={`blueGray`} onClick={this.openCropperImage}>{`Upload image`}</AxlButton>
            <E.Label>Only PNG file is allowed</E.Label>
          </E.Row_1>
          {this.state.isOpenCropper &&
          <AxlModal onClose={this.closeCropperImage} style={styles.cropperModal}>
            <AxlUploadCropImage adding={uploadingLogo} onOK={this.uploadImage} onCancel={this.closeCropperImage} title={`Drag 'n' drop logo here, or click to select logo`} />
          </AxlModal>}
        </AxlPanel.Row>
      </AxlPanel>
    </E.Container>
  }
}

export default AccountLabel;